export function ColorWin32ToRGB(num: number) {
    num >>>= 0;

    var r = num & 0xFF,

        g = (num & 0xFF00) >>> 8,

        b = (num & 0xFF0000) >>> 16

     return "rgb(" + [r, g, b].join(",") + ")";
}
export function ColorRGBToWin32(r: any, g: any, b: any) {
    return ((1 << 24) + (r << 16) + (g << 8) + b).toString()
}